import cx from 'classnames'

import { SanityFreeform } from '@data/sanity/queries/types/blocks'

import ComplexPortableText from '@components/portable-text/complex'

type FreeformProps = SanityFreeform

const Freeform = ({ maxWidth, textAlign, content }: FreeformProps) => {
  if (!content) {
    return null
  }

  return (
    <ComplexPortableText
      content={content}
      className={cx('rc', maxWidth, textAlign)}
    />
  )
}

export default Freeform
